import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'xp-file-row',
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatIconModule],
	templateUrl: './xp-file-row.component.html',
	styleUrls: ['./xp-file-row.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpFileRowComponent {
	thumbSrc = input('');
	isPdf = input(false);
	pdfIconSrc = input('');
	iconSrc = input('');
	name = input('');
	caption = input('');
	removeIcon = input('');
	removeIconSrc = input('');
	removeLabel = input('Remove');

	remove = output<void>();

	readonly thumb = computed(() => (this.isPdf() ? this.pdfIconSrc() : this.thumbSrc()));
}
